import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ServiceRequest from './ServiceRequest';
import Header from '../../common/header/header';

const WrapperWithHeaderOnly = ({ children }) => {
    return (
        <div className="outer-wrapper">
            <div className="body-outer">
                <div className="body-wrapper">
                    {children}
                </div>
            </div>
        </div>
    )
}

const ServiceRequestWrapper = () => {
    const [searchParams] = useSearchParams();
    const paramsObj = Object.fromEntries(searchParams?.entries());
    
    // If fromPatient is false or encounterId is present, use header-only layout (popup style)
    // Otherwise use full layout
    const isPopupMode = paramsObj?.fromPatient === "false" || paramsObj?.encounterId;
    
    if (isPopupMode) {
        return (
            <WrapperWithHeaderOnly>
                <ServiceRequest />
            </WrapperWithHeaderOnly>
        );
    }
    
    // Full layout (default)
    return <ServiceRequest />;
};

export default ServiceRequestWrapper;
